import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useDispatch } from 'react-redux'
import { componentBoxHideAction } from 'src/reducers/component-box/action'
import styles from './styles'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import CertificateBuilder from '@minicoursegenerator/certificate-builder'
import { CoreButton } from 'src/components/core'
import UserType from 'src/model/user-types'
import UpgradePopover from 'src/components/upgrade-popover/upgrade-popover'
import {
  certificateElementBackground,
  certificateElementBlocks,
} from './certificate'

const CertificateListHeader = props => {
  const { classes, text, showIcon, value, editHtmlValue } = props
  const dispatch = useDispatch()

  const [anchorEl, setAnchorEl] = React.useState(null)

  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
  const hasTemplateAccess = () => {
    if (
      userControl == 'Elite' ||
      userControl == 'AppSumo (Tier 5)' ||
      userControl == 'AppSumo (Tier 6)' ||
      userControl == 'AppSumo (Tier 7)' ||
      userControl == 'AppSumo (Tier 8)' ||
      userControl == 'AppSumo (Tier 9)' ||
      userControl == 'Super Admin' ||
      // Certifications start at Pro v2; the Plus plan doesn't include them.
      userControl == 'Pro v2' ||
      userControl == 'Launch' ||
      userControl == 'Essentials' ||
      userControl == 'Growth' ||
      userControl == 'Scale' ||
      userControl == 'Enterprise' ||
      UserType.isTrialEquivalent(userControl)
    ) {
      return true
    }
    return false
  }

  // Popup kontrolü
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'certificate-popover' : undefined

  const hide = () => {
    dispatch(componentBoxHideAction())
  }

  const handleSave = (html, blocks, background) => {
    if (editHtmlValue) {
      dispatch(messageBoxHideAction())
      editHtmlValue(html, blocks, background)
    }
  }
  const handleCancel = () => {
    dispatch(messageBoxHideAction())
  }
  const handleTemplateEdit = () => {
    dispatch(componentBoxHideAction())
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          title: `<div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
              "
            >
              <Typography>Create template</Typography>
            </div>`,
          buttons: [],
          component: (
            <CertificateBuilder
              initialBlock={certificateElementBlocks}
              initialBackground={certificateElementBackground}
              saveHtml={handleSave}
              cancel={handleCancel}
            />
          ),
          callback: () => {},
        }),
      ),
    )
  }

  const handleCreateTemplateClick = event => {
    if (hasTemplateAccess()) {
      handleTemplateEdit()
    } else {
      handleClick(event)
    }
  }

  return (
    <div className={classes.header}>
      <Typography className={classes.typography}>{text}</Typography>
      {showIcon && (
        <Icon icon="uiw:close" onClick={hide} className={classes.icon} />
      )}
      {value === 'certificateTemplates' && (
        <>
          <div>
            <CoreButton
              onClick={handleCreateTemplateClick}
              size="medium"
              color="secondary"
              variant="contained"
            >
              Create template
            </CoreButton>
          </div>
          {/* Upgrade Popup */}
          <UpgradePopover
            id={id}
            anchorEl={anchorEl}
            handleClose={handleClose}
            open={open}
            header={'Upgrade to Pro'}
            content={'Upgrade to Pro plan to access advanced features.'}
            accessRuleEqual={3}
          />
        </>
      )}
    </div>
  )
}

export default withStyles(styles)(CertificateListHeader)
